class HeaderReviewSlider extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.header-review-slider__item'));
    if (this.items.length < 2) return;

    this.intervalMs = parseInt(this.dataset.interval, 10) || 2500;
    this.activeIndex = Math.max(
      0,
      this.items.findIndex((item) => item.classList.contains('is-active'))
    );
    this.timer = null;

    this._onMouseEnter = () => this.pause();
    this._onMouseLeave = () => this.start();

    this.start();
    this.addEventListener('mouseenter', this._onMouseEnter);
    this.addEventListener('mouseleave', this._onMouseLeave);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  disconnectedCallback() {
    this.pause();
    this.removeEventListener('mouseenter', this._onMouseEnter);
    this.removeEventListener('mouseleave', this._onMouseLeave);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  onVisibilityChange = () => {
    if (document.hidden) {
      this.pause();
    } else {
      this.start();
    }
  };

  start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (this.items.length < 2) return;
    if (this.timer) return;
    this.timer = window.setInterval(() => this.next(), this.intervalMs);
  }

  pause() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    const current = this.items[this.activeIndex];
    this.activeIndex = (this.activeIndex + 1) % this.items.length;
    const next = this.items[this.activeIndex];

    current.classList.remove('is-active');
    current.setAttribute('aria-hidden', 'true');
    next.classList.add('is-active');
    next.removeAttribute('aria-hidden');
  }
}

if (!customElements.get('header-review-slider')) {
  customElements.define('header-review-slider', HeaderReviewSlider);
}
